module.exports = __webpack_public_path__ + "static/img/options-exchange.1770538668457.png";